import { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "hooks/useAuthUser";
import { Routes } from "../../router/config";

function useController() {
  const { user } = useAuthUser();
  const history = useHistory();
  const match = useRouteMatch();

  const [senderUser, setSenderUser] = useState<UserPublicData | null>(null);

  const onClickBackButton = () => {
    history.push(Routes.messages);
  };

  return {
    setSenderUser,
    user,
    onClickBackButton,
    match,
    isSelectThread: history.location.pathname !== match.url,
  };
}

export default useController;
